
export enum LookupsRoutes {
  MonitoringComplaints = 'monitoring-complaints',
  infractionDetails = 'infraction-Details',
}

